<br/>
<div class="row">
  <p-listbox *ngIf="listOfUPC?.length && viewLevel === ViewLevel.Product"
             [options]="listOfUPC"
             [ngModel]="selectedUPC"
             (ngModelChange)="onUPCChange($event)"
             optionLabel="name"
  >
    <ng-template let-upcItem pTemplate="item">
      <div class="upc-item">
        <div>{{upcItem.request.upc}} ({{upcItem.request?.name }})</div>
      </div>
    </ng-template>
  </p-listbox>

  <!-- Product Table -->
  <div class="panel panel-body" style="margin-bottom: 20px;margin-top: -20px;" *ngIf="listOfUPC?.length && viewLevel === ViewLevel.Group">
    <ng-container *ngIf="dataSource">
      <mat-table #table [dataSource]="dataSource" matSort class="full-width-table">
        <ng-container matColumnDef="productUPC">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Product UPC</mat-header-cell>
          <mat-cell *matCellDef="let item">{{item.request.upc}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="inCommProductName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>InComm Product Name</mat-header-cell>
          <mat-cell *matCellDef="let item">{{item.request?.name}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </ng-container>
  </div>

  <div class="col-md-12" *ngIf="viewLevel else singleUPCLayout">
    <ng-container *ngIf="viewLevel === ViewLevel.Group; else groupUPCsLayout">
      <p-tabView styleClass="header-disclick" [(activeIndex)]="index">
        <p-tabPanel class="pl-0 pr-0">
          <ng-template pTemplate="header">
            <div (click)="handleTabChange($event,0)">
              Text Assets
            </div>
          </ng-template>
          <app-group-marketing-details [data]="data"
                                       [isActionsDisabled]="isActionsDisabled"
                                       [marketingDetails]="productRequest.get('marketingDetails')"
                                       [groupAttributes]="groupAttributes"
                                       [isShowWarning]="isShowWarning"
                                       (save)="onSaveProduct($event)"
                                       (cancel)="cancel.emit()"
                                       >
          </app-group-marketing-details>
          <app-group-redemption-details [data]="data"
                                        [isActionsDisabled]="isActionsDisabled"
                                        [groupAttributes]="groupAttributes"
                                        [redemptionDetails]="productRequest.get('redemptionDetails')"
                                        [isShowWarning]="isShowWarning"
                                        (save)="onSaveProduct($event)"
                                        (cancel)="cancel.emit()"
                                        >
          </app-group-redemption-details>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <div (click)="handleTabChange($event,1)">
              Image Assets
            </div>
          </ng-template>
          <div class="panel b">
            <div class="fs-4 panel-heading bg-gray-lighter text-bold">{{EN['DIGITAL_FILES_ORIGINAL_HEADING']}}</div>
            <hr>
            <app-digital-files [viewLevel]="ViewLevel.Group"
                               [isActionsDisabled]="isActionsDisabled"
                               [groupProduct]="selectedUPC"
                               [groupAttributes]="groupAttributes"
                               [data]="data.dpamRequestOriginalFiles"
                               [fileGroup]="'original'"
                               [dpamRequest]="data.dpamRequest"
                               [editorEnable]="true"
            ></app-digital-files>
            <div class="mt-3 panel-heading bg-gray-lighter text-bold with-icon mb-3 fs-4 mt-6">
              {{EN['DIGITAL_FILES_FINAL_HEADING']}}
              <em [matTooltip]="'Minimum requirement: 1 Card Image (M6 OR CR80, prefer PNG) and 1500x1500 (Must be JPG). Image Types Supported: PNG or JPG'"
                  class="icon-question ml-3"></em>
            </div>
            <hr>
            <app-digital-files [viewLevel]="ViewLevel.Group"
                               [isActionsDisabled]="isActionsDisabled"
                               [groupProduct]="selectedUPC"
                               [groupAttributes]="groupAttributes"
                               [data]="data.dpamRequestFinalFiles"
                               [dpamRequest]="data.dpamRequest"
                               [fileGroup]="'final'"
            ></app-digital-files>
          </div>
        </p-tabPanel>
      </p-tabView>
    </ng-container>
  </div>
</div>

<ng-template #groupUPCsLayout>
  <p-tabView styleClass="header-disclick" [(activeIndex)]="index">
    <p-tabPanel class="pl-0 pr-0">
      <ng-template pTemplate="header">
        <div (click)="handleTabChange($event,0)">
          Text Assets
        </div>
      </ng-template>
      <app-marketing-details [data]="data"
                             [isActionsDisabled]="isActionsDisabled"
                             [marketingDetails]="productRequest.get('marketingDetails')"
                             [groupAttributes]="groupAttributes"
                             [isShowWarning]="isShowWarning"
                             (save)="onSaveProduct($event)"
                             (cancel)="cancel.emit()"
      >
      </app-marketing-details>
      <app-redemption-details [data]="data"
                              [isActionsDisabled]="isActionsDisabled"
                              [groupAttributes]="groupAttributes"
                              [redemptionDetails]="productRequest.get('redemptionDetails')"
                              [isShowWarning]="isShowWarning"
                              (save)="onSaveProduct($event)"
                              (cancel)="cancel.emit()"
      >
      </app-redemption-details>
    </p-tabPanel>
    <p-tabPanel>
      <ng-template pTemplate="header">
        <div (click)="handleTabChange($event,1)">
          Image Assets
        </div>
      </ng-template>
      <div class="panel b">
        <div class="fs-4 panel-heading bg-gray-lighter text-bold">{{EN['DIGITAL_FILES_ORIGINAL_HEADING']}}</div>
        <hr>
        {{selectedUPC?.request?.productRequest?.upc}}
        <app-digital-files [groupAttributes]="groupAttributes"
                           [isActionsDisabled]="isActionsDisabled"
                           [groupProduct]="selectedUPC"
                           [viewLevel]="ViewLevel.Product"
                           [data]="data.dpamRequestOriginalFiles"
                           [fileGroup]="'original'"
                           [dpamRequest]="data.dpamRequest"
                           (addSpecificComment)="onAddComment($event)"
                           [editorEnable]="true"
        ></app-digital-files>
        <div class="mt-3 panel-heading bg-gray-lighter text-bold with-icon mb-3 fs-4 mt-6">
          {{EN['DIGITAL_FILES_FINAL_HEADING']}}
          <em [matTooltip]="'Minimum requirement: 1 Card Image (M6 OR CR80, prefer PNG) and 1500x1500 (Must be JPG). Image Types Supported: PNG or JPG'"
              class="icon-question ml-3"></em>
        </div>
        <hr>
        {{selectedUPC?.request?.productRequest?.upc}}
        <app-digital-files [groupProduct]="selectedUPC"
                           [isActionsDisabled]="isActionsDisabled"
                           [groupAttributes]="groupAttributes"
                           [viewLevel]="ViewLevel.Product"
                           [data]="data.dpamRequestFinalFiles"
                           [dpamRequest]="data.dpamRequest"
                           [fileGroup]="'final'"
                           (addSpecificComment)="onAddComment($event)"
        ></app-digital-files>
      </div>
    </p-tabPanel>
  </p-tabView>
</ng-template>

<ng-template #singleUPCLayout>
  <div class="col-md-12">
    <p-tabView styleClass="header-disclick" [(activeIndex)]="index">
      <p-tabPanel class="pl-0 pr-0">
        <ng-template pTemplate="header">
          <div (click)="handleTabChange($event,0)">
            Text Assets
          </div>
        </ng-template>
        <app-marketing-details [data]="data"
                               [isActionsDisabled]="isActionsDisabled"
                               [marketingDetails]="productRequest.get('marketingDetails')"
                               [isShowWarning]="isShowWarning"
                               (save)="onSaveProduct($event)"
                               (cancel)="cancel.emit()">
        </app-marketing-details>
        <app-redemption-details [data]="data"
                                [isActionsDisabled]="isActionsDisabled"
                                [redemptionDetails]="productRequest.get('redemptionDetails')"
                                [isShowWarning]="isShowWarning"
                                (save)="onSaveProduct($event)"
                                (cancel)="cancel.emit()">
        </app-redemption-details>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div (click)="handleTabChange($event,1)">
            Image Assets
          </div>
        </ng-template>
        <div class="panel b">
          <div class="fs-4 panel-heading bg-gray-lighter text-bold">{{EN['DIGITAL_FILES_ORIGINAL_HEADING']}}</div>
          <hr>
          <app-digital-files [data]="data.dpamRequestOriginalFiles"
                             [isActionsDisabled]="isActionsDisabled"
                             [dpamRequest]="data.dpamRequest"
                             [fileGroup]="'original'"
                             (addSpecificComment)="onAddComment($event)"
                             [editorEnable]="true"
          ></app-digital-files>
          <div class="mt-3 panel-heading bg-gray-lighter text-bold with-icon mb-3 fs-4 mt-6">
            {{EN['DIGITAL_FILES_FINAL_HEADING']}}
            <em [matTooltip]="'Minimum requirement: 1 Card Image (M6 OR CR80, prefer PNG) and 1500x1500 (Must be JPG). Image Types Supported: PNG or JPG'"
                class="icon-question ml-3"></em>
          </div>
          <hr>
          <app-digital-files [data]="data.dpamRequestFinalFiles"
                             [isActionsDisabled]="isActionsDisabled"
                             [dpamRequest]="data.dpamRequest"
                             [fileGroup]="'final'"
          ></app-digital-files>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-template>
